<template>
  <div class="order-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.orderId" placeholder="请输入订单号" clearable />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable>
            <el-option label="已拒绝" :value="2" />
            <el-option label="执行中" :value="3" />
            <el-option label="已完成" :value="4" />
            <el-option label="已取消" :value="5" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 订单列表表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="orderList"
        height="56vh"
        border
        stripe
        @row-click="handleViewDetail"
        style="width: 100%"
      >
        <el-table-column prop="displayPaiOrderNo" label="订单号" min-width="200" show-overflow-tooltip />
        <el-table-column prop="brandName" label="店铺名称" min-width="150" />
        <el-table-column prop="jxName" label="经销商" min-width="120" />
        <el-table-column prop="statusText" label="订单状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small">
              {{ scope.row.statusText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="totalQuantity" label="商品总数" width="100" align="center" />
        <el-table-column prop="comlistF1" label="订单金额(元)" width="130">
          <template slot-scope="scope">
            <span class="money">¥{{ parseFloat(scope.row.comlistF1 || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" width="180" />
        <el-table-column prop="com_name" label="购买公司名称" width="180" />
        <el-table-column prop="buyer_name" label="下单人" width="180" />
        <el-table-column prop="buyer_phone" label="联系电话" width="180" />
        <el-table-column label="操作" min-width="120" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 3"
              type="primary"
              size="mini"
              icon="el-icon-s-promotion"
              @click.stop="openShipDialog(scope.row)"
            >
              发货
            </el-button>
            <el-button
              v-if="scope.row.status === 4"
              type="primary"
              size="mini"
              icon="el-icon-edit-outline"
              @click.stop="openShipDialog(scope.row)"
            >
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="65%" top="5vh">
      <el-descriptions :column="2" border v-if="currentOrder" class="detail-descriptions">
        <el-descriptions-item label="派单ID">{{ currentOrder.id }}</el-descriptions-item>
        <el-descriptions-item label="订单号">{{ currentOrder.orderId }}</el-descriptions-item>
        <el-descriptions-item label="店铺名称">{{ currentOrder.brandName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="经销商">{{ currentOrder.jxName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag :type="getStatusType(currentOrder.status)">
            {{ getStatusText(currentOrder.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="订单金额">
          <span class="money">¥{{ parseFloat(currentOrder.comlistF1 || 0).toFixed(2) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="商品总数">{{ currentOrder.totalQuantity || 0 }}</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ currentOrder.createTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="接单时间">{{ currentOrder.acceptTime || '未接单' }}</el-descriptions-item>
        <el-descriptions-item label="发货时间">{{ currentOrder.dispatchTime || '未发货' }}</el-descriptions-item>
        <el-descriptions-item label="完成时间">{{ currentOrder.completeTime || '未完成' }}</el-descriptions-item>
        <el-descriptions-item label="拒绝原因">{{ currentOrder.rejectReason || '-' }}</el-descriptions-item>
         <el-descriptions-item label="购买公司名称">{{ currentOrder.com_name }}</el-descriptions-item>
        <el-descriptions-item label="收货地址">{{ currentOrder.crm_address }}</el-descriptions-item>
      </el-descriptions>

      <div v-if="currentOrder && currentOrder.mx && currentOrder.mx.length" class="mx-section">
        <h4 class="mx-title">商品明细</h4>
        <el-table :data="currentOrder.mx" border stripe size="small">
          <el-table-column prop="goodsName" label="商品名称" min-width="280" show-overflow-tooltip />
          <el-table-column prop="comlistS1" label="数量" width="100" align="center" />
          <el-table-column prop="comlistF1" label="单价(元)" width="120" align="center">
            <template slot-scope="scope">
              ¥{{ parseFloat(scope.row.comlistF1 || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="comlistF2" label="小计(元)" width="120" align="center">
            <template slot-scope="scope">
               ¥{{ (parseFloat(scope.row.comlistS1) * parseFloat(scope.row.comlistF1)).toFixed(2) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 0 ? 'warning' : 'success'" size="mini">
                {{ scope.row.status === 0 ? '待处理' : '已完成' }}
              </el-tag>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- ============================================================ -->
    <!-- 发货弹窗（改造：新增物流单 + 保存 + 确认发货）                -->
    <!-- ============================================================ -->
    <el-dialog
      title="发货"
      :visible.sync="shipDialogVisible"
      width="80%"
      top="5vh"
      :close-on-click-modal="false"
      @close="resetShipForm"
    >
      <!-- 订单信息 -->
      <div class="ship-header">
        <el-descriptions :column="3" border size="small">
          <el-descriptions-item label="订单号">
            {{ shipOrder ? shipOrder.displayPaiOrderNo : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="店铺">
            {{ shipOrder ? shipOrder.brandName : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="经销商">
            {{ shipOrder ? shipOrder.jxName : '-' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- ========== 已保存的物流单列表 ========== -->
      <div class="ship-goods-section">
        <div class="section-header">
          <h4 class="ship-title">物流单列表</h4>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddShipDialog">
            新增物流单
          </el-button>
        </div>

        <el-table
          :data="shipGoodsList"
          border
          stripe
          v-loading="shipLoading"
          empty-text="暂无物流单，请点击「新增物流单」添加"
        >
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="goodsName" label="商品名称" min-width="200" show-overflow-tooltip />
          <el-table-column prop="code" label="物流单号" min-width="160" show-overflow-tooltip />
          <el-table-column prop="quantity" label="发货数量" width="120" align="center" />
          <el-table-column prop="totalQty" label="总数量" width="100" align="center" />
          <el-table-column label="可分配数量" width="120" align="center">
            <template slot-scope="scope">
              {{ getAvailableQty(scope.row.goodsId) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 0 ? 'warning' : 'success'" size="mini">
                {{ scope.row.status === 0 ? '待发货' : '已发货' }}
              </el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column label="操作" width="80" align="center" fixed="right"> -->
            <!-- <template slot-scope="scope"> -->
              <!-- <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                @click="deleteShipItem(scope.row)"
              /> -->
            <!-- </template> -->
          <!-- </el-table-column> -->
        </el-table>

        <div class="ship-total">
          <span>合计发货：<strong>{{ shipTotalQuantity }}</strong> 件</span>
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="shipDialogVisible = false">取 消</el-button>
        <el-button
          type="success"
          :loading="shipLoading"
          @click="submitSave"
          icon="el-icon-document"
        >
          保存
        </el-button> -->
        <el-button
          type="primary"
          :loading="shipLoading"
          @click="submitShip"
          icon="el-icon-s-promotion"
        >
          确认发货
        </el-button>
      </span>
    </el-dialog>

    <!-- ========== 新增物流单对话框 ========== -->
    <el-dialog
      title="新增物流单"
      :visible.sync="addShipDialogVisible"
      width="520px"
      top="20vh"
      :close-on-click-modal="false"
      @close="resetAddShipForm"
    >
      <el-form
        ref="addShipForm"
        :model="addShipForm"
        :rules="addShipRules"
        label-width="120px"
        label-position="right"
      >
        <el-form-item label="货品" prop="goodsId">
          <el-select
            v-model="addShipForm.goodsId"
            placeholder="请选择商品"
            filterable
            style="width: 100%"
            @change="onGoodsChange"
          >
            <el-option
              v-for="item in availableGoodsOptions"
              :key="item.goodsId"
              :label="item.goodsName"
              :value="item.goodsId"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="物流单号" prop="code">
          <el-input
            v-model="addShipForm.code"
            placeholder="请输入物流单号（必填）"
            clearable
          />
        </el-form-item>

        <el-form-item label="数量" prop="quantity">
          <el-input-number
            v-model="addShipForm.quantity"
            :min="1"
            :max="addShipForm.maxQuantity"
            :precision="0"
            controls-position="right"
            style="width: 100%"
          />
          <div style="color: #909399; font-size: 13px; margin-top: 4px;">
            可分配数量：{{ addShipForm.availableQty }}
          </div>
        </el-form-item>

        <el-form-item label="总数量">
          <span>{{ addShipForm.totalQty || 0 }}</span>
        </el-form-item>

        <el-form-item label="可分配数量">
          <span style="color: #409EFF; font-weight: 600;">
            {{ addShipForm.availableQty || 0 }}
          </span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addShipDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="addShipLoading"
          @click="submitAddShip"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'OrderList',
  data () {
    return {
      // ---- 列表 ----
      loading: false,
      orderList: [],
      filterForm: {
        orderId: '',
        status: '',
        startTime: '',
        endTime: ''
      },
      dateRange: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      dialogVisible: false,
      currentOrder: null,

      // ---- 发货弹窗 ----
      shipDialogVisible: false,
      shipLoading: false,
      shipOrder: null,
      // 物流单列表：每个元素 { id, goodsId, goodsName, code, quantity, totalQty, status }
      shipGoodsList: [],

      // ---- 新增物流单对话框 ----
      addShipDialogVisible: false,
      addShipLoading: false,
      addShipForm: {
        goodsId: '',
        code: '',
        quantity: 1,
        totalQty: 0,
        availableQty: 0,
        maxQuantity: 999999
      },
      addShipRules: {
        goodsId: [{ required: true, message: '请选择商品', trigger: 'change' }],
        code: [{ required: true, message: '请输入物流单号', trigger: 'blur' }],
        quantity: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '数量至少为1', trigger: 'blur' }
        ]
      },
      // 订单原始商品列表（用于计算可分配数量），字段已映射为驼峰
      originalGoodsList: []
    }
  },

  computed: {
    shipTotalQuantity () {
      if (!this.shipGoodsList || !this.shipGoodsList.length) return 0
      return this.shipGoodsList.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0)
    },
    // 可供选择的商品列表（未分配完的商品）
    availableGoodsOptions () {
      if (!this.originalGoodsList || !this.originalGoodsList.length) return []
      return this.originalGoodsList.filter(item => {
        const available = this.getAvailableQty(item.goodsId)
        return available > 0
      })
    }
  },

  mounted () {
    this.getOrderList()
  },

  methods: {
    // ---- 辅助 ----
    getStatusText (status) {
      const map = {
        2: '已拒绝',
        3: '执行中',
        4: '已完成',
        5: '已取消'
      }
      return map[status] || '未知状态'
    },

    getStatusType (status) {
      const map = {
        2: 'danger',
        3: 'warning',
        4: 'success',
        5: 'info'
      }
      return map[status] || 'info'
    },

    // 计算某个商品的可分配数量 = 总数量 - 已分配数量
    getAvailableQty (goodsId) {
      const original = this.originalGoodsList.find(item => item.goodsId === goodsId)
      if (!original) return 0
      const total = parseInt(original.comlistS1) || 0
      const used = this.shipGoodsList
        .filter(item => item.goodsId === goodsId)
        .reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0)
      return Math.max(total - used, 0)
    },

    // ---- 订单列表 ----
    async getOrderList () {
      this.loading = true
      try {
        const params = {
          a: 'paiLists',
          page: this.currentPage,
          page_size: this.pageSize,
          jx_id: localStorage.getItem('jx_id') || ''
        }

        if (this.filterForm.orderId) params.order_id = this.filterForm.orderId
        if (this.filterForm.status !== '' && this.filterForm.status !== null) {
          params.status = this.filterForm.status
        }
        if (this.filterForm.startTime) params.start_time = this.filterForm.startTime
        if (this.filterForm.endTime) params.end_time = this.filterForm.endTime

        const response = await request.post('/order/order_pai.php', params)

        if (response.code === '0') {
          const rawData = response.data || []
          this.orderList = rawData.map(item => {
            const statusNum = parseInt(item.status)
            let totalQty = 0
            if (item.mx && Array.isArray(item.mx)) {
              totalQty = item.mx.reduce((sum, mx) => sum + parseInt(mx.comlist_s1 || 0), 0)
            }
            return {
              ...item,
              id: item.id,
              orderId: item.order_id,
              displayPaiOrderNo: item.pai_order_no,
              brandName: item.brand_name,
              jxName: item.jx_name,
              status: statusNum,
              statusText: this.getStatusText(statusNum),
              totalQuantity: totalQty,
              comlistF1: item.comlist_f1,
              createTime: item.create_time,
              acceptTime: item.accept_time,
              dispatchTime: item.dispatch_time,
              completeTime: item.complete_time,
              rejectReason: item.reject_reason,
              brandId: item.brand_id,
              mx: item.mx ? item.mx.map(mx => ({
                ...mx,
                id: mx.id,
                goodsId: mx.goods_id,
                goodsName: mx.goods_name,
                comlistS1: mx.comlist_s1,
                comlistF1: mx.comlist_f1,
                comlistF2: mx.comlist_f2,
                status: mx.status
              })) : []
            }
          })
          this.pages = response.pages || 0
          this.total = this.pages * this.pageSize
        } else if (response.code === 1001) {
          this.$message.error('请先登录')
          this.orderList = []
          this.total = 0
        } else {
          this.$message.error(response.msg || '获取订单列表失败')
          this.orderList = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求订单列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.orderList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      if (this.dateRange && this.dateRange.length === 2) {
        this.filterForm.startTime = this.dateRange[0]
        this.filterForm.endTime = this.dateRange[1]
      } else {
        this.filterForm.startTime = ''
        this.filterForm.endTime = ''
      }
      this.currentPage = 1
      this.getOrderList()
    },

    handleReset () {
      this.filterForm = {
        orderId: '',
        status: '',
        startTime: '',
        endTime: ''
      }
      this.dateRange = []
      this.currentPage = 1
      this.getOrderList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getOrderList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.getOrderList()
    },

    handleViewDetail (row) {
      this.currentOrder = {
        ...row,
        status: parseInt(row.status)
      }
      this.dialogVisible = true
    },

    // ================================================================
    // 发货弹窗
    // ================================================================

    // 新增：从接口获取已保存的物流单列表
    async fetchShipList (orderDh, brandId, jxId) {
      try {
        const response = await request.post('/logistics/wuliu_list.php', {
          sh_id: brandId,
          jx_id: jxId,
          comlist_v1: orderDh
        })
        if (response.code === 0) {
          // 根据实际返回字段调整映射，此处假设返回 data 为数组
          const list = response.data || []
          this.shipGoodsList = list.map(item => ({
            id: item.id,
            mxId: item.mx_list[0].id,
            goodsId: item.mx_list[0].goods_id,
            goodsName: item.mx_list[0].goods_name,
            code: item.mx_list[0].code,
            quantity: parseInt(item.mx_list[0].comlist_s2 || 0),
            totalQty: parseInt(item.mx_list[0].total_qty || 0), // 若后端返回
            status: item.mx_list[0].status || 0
          }))
        } else {
          this.$message.error(response.msg || '获取物流单失败')
          this.shipGoodsList = []
        }
      } catch (error) {
        console.error('获取物流单列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.shipGoodsList = []
      }
    },

    // 打开发货弹窗：初始化数据
    openShipDialog (row) {
      console.log(row)
      this.shipOrder = JSON.parse(JSON.stringify(row))
      // 保存原始商品列表（映射为驼峰）
      this.originalGoodsList = (this.shipOrder.mx && Array.isArray(this.shipOrder.mx))
        ? this.shipOrder.mx.map(item => ({
          id: item.id,
          goodsId: item.goodsId,
          goodsName: item.goodsName,
          comlistS1: item.comlistS1,
          comlistF1: item.comlistF1,
          comlistF2: item.comlistF2,
          status: item.status
        }))
        : []

      const jxId = localStorage.getItem('jx_id')
      if (!jxId) {
        this.$message.error('请先登录')
        return
      }

      // 从接口加载物流单（不再使用 localStorage）
      this.fetchShipList(this.shipOrder.displayPaiOrderNo, this.shipOrder.brandId, jxId)

      this.shipDialogVisible = true
    },

    // 关闭发货弹窗
    resetShipForm () {
      this.shipOrder = null
      this.shipGoodsList = []
      this.originalGoodsList = []
      this.shipLoading = false
    },

    // ---- 新增物流单 ----
    openAddShipDialog () {
      // 检查是否还有可分配的商品
      if (this.availableGoodsOptions.length === 0) {
        this.$message.warning('所有商品已分配完毕，无法新增物流单')
        return
      }
      // 重置表单
      this.addShipForm = {
        goodsId: '',
        code: '',
        quantity: 1,
        totalQty: 0,
        availableQty: 0,
        maxQuantity: 999999
      }
      // 默认选中第一个可分配的商品
      if (this.availableGoodsOptions.length > 0) {
        const first = this.availableGoodsOptions[0]
        this.addShipForm.goodsId = first.goodsId
        this.onGoodsChange(first.goodsId)
      }
      // 清空校验
      this.$nextTick(() => {
        if (this.$refs.addShipForm) {
          this.$refs.addShipForm.clearValidate()
        }
      })
      this.addShipDialogVisible = true
    },

    // 选择商品变化时，更新总数量、可分配数量
    onGoodsChange (goodsId) {
      if (!goodsId) {
        this.addShipForm.totalQty = 0
        this.addShipForm.availableQty = 0
        this.addShipForm.maxQuantity = 0
        return
      }
      const original = this.originalGoodsList.find(item => item.goodsId === goodsId)
      if (!original) {
        this.addShipForm.totalQty = 0
        this.addShipForm.availableQty = 0
        this.addShipForm.maxQuantity = 0
        return
      }
      const total = parseInt(original.comlistS1) || 0
      const available = this.getAvailableQty(goodsId)
      this.addShipForm.totalQty = total
      this.addShipForm.availableQty = available
      this.addShipForm.maxQuantity = available
      // 如果当前数量超过可分配数量，自动修正
      if (this.addShipForm.quantity > available) {
        this.addShipForm.quantity = Math.max(available, 1)
      }
    },

    // 重置新增物流单表单
    resetAddShipForm () {
      this.addShipForm = {
        goodsId: '',
        code: '',
        quantity: 1,
        totalQty: 0,
        availableQty: 0,
        maxQuantity: 999999
      }
      this.addShipLoading = false
      if (this.$refs.addShipForm) {
        this.$refs.addShipForm.clearValidate()
      }
    },

    // 提交新增物流单（保存 a:"baocun"）
    submitAddShip () {
      this.$refs.addShipForm.validate(async (valid) => {
        if (!valid) return

        const { goodsId, code, quantity } = this.addShipForm
        // 再次校验可分配数量
        const available = this.getAvailableQty(goodsId)
        if (quantity > available) {
          this.$message.error(`发货数量不能超过可分配数量（${available}）`)
          return
        }

        // 获取商品信息
        const original = this.originalGoodsList.find(item => item.goodsId === goodsId)
        if (!original) {
          this.$message.error('商品信息不存在')
          return
        }

        const jxId = localStorage.getItem('jx_id')
        if (!jxId) {
          this.$message.error('请先登录')
          return
        }

        // 构建保存请求参数 (a:"baocun")，使用下划线字段名
        const goodsList = [{
          order_mx_id: parseInt(original.id),
          goods_id: parseInt(goodsId),
          goods_name: original.goodsName,
          comlist_s2: parseInt(quantity),
          code: code.trim()
        }]

        const requestBody = {
          sh_id: parseInt(this.shipOrder.brandId),
          jx_id: parseInt(jxId),
          order_id: parseInt(this.shipOrder.id),
          list: [
            {
              goods_list: goodsList
            }
          ]
        }

        console.log('保存物流单请求参数:', requestBody)

        this.addShipLoading = true
        try {
          const response = await request.post('/logistics/wuliu_add.php', requestBody)
          console.log(response)
          if (response.code === 0) {
            this.$message.success(response.res || '物流单保存成功！')
            // 重新获取列表以刷新数据
            await this.fetchShipList(this.shipOrder.displayPaiOrderNo, this.shipOrder.brandId, jxId)
            this.addShipDialogVisible = false
            this.resetAddShipForm()
          } else if (response.code === 1001) {
            this.$message.error('请先登录')
          } else {
            this.$message.error(response.msg || '保存失败，请重试')
          }
        } catch (error) {
          console.error('保存物流单出错:', error)
          this.$message.error('网络错误，请稍后重试')
        } finally {
          this.addShipLoading = false
        }
      })
    },

    // ---- 删除物流单（仅本地移除，需点击“保存”按钮使更改生效） ----
    deleteShipItem (row) {
      this.$confirm(`确定要删除商品「${row.goodsName}」的物流单吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.shipGoodsList.findIndex(item => item.id === row.id)
        if (index !== -1) {
          this.shipGoodsList.splice(index, 1)
          this.$message.success('已移除，请点击“保存”按钮使更改生效')
        }
      }).catch(() => {})
    },

    // ---- 保存所有物流单（a:"baocun"） ----
    async submitSave () {
      if (!this.shipGoodsList || this.shipGoodsList.length === 0) {
        this.$message.warning('暂无物流单可保存')
        return
      }

      const jxId = localStorage.getItem('jx_id')
      if (!jxId) {
        this.$message.error('请先登录')
        return
      }

      // 构建商品列表：所有物流单合并，使用下划线字段名
      const goodsList = this.shipGoodsList
        .filter(item => parseInt(item.quantity) > 0)
        .map(item => {
          const original = this.originalGoodsList.find(g => g.goodsId === item.goodsId)
          return {
            order_mx_id: parseInt(original ? original.id : 0),
            goods_id: parseInt(item.goodsId),
            goods_name: item.goodsName,
            comlist_s2: parseInt(item.quantity),
            code: item.code || ''
          }
        })

      if (goodsList.length === 0) {
        this.$message.warning('没有有效的物流单数据')
        return
      }

      const requestBody = {
        // a: 'baocun',
        sh_id: parseInt(this.shipOrder.brandId),
        jx_id: parseInt(jxId),
        order_id: parseInt(this.shipOrder.id),
        list: [
          {
            goods_list: goodsList
          }
        ]
      }

      console.log('批量保存物流单请求参数:', requestBody)

      this.shipLoading = true
      try {
        const response = await request.post('/logistics/wuliu_add.php', requestBody)

        if (response.code === 0) {
          this.$message.success(response.res || '所有物流单保存成功！')
          // 保存成功后重新获取列表，保证数据同步
          await this.fetchShipList(this.shipOrder.displayPaiOrderNo, this.shipOrder.brandId, jxId)
        } else if (response.code === 1001) {
          this.$message.error('请先登录')
        } else {
          this.$message.error(response.msg || '保存失败，请重试')
        }
      } catch (error) {
        console.error('批量保存物流单出错:', error)
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.shipLoading = false
      }
    },

    // ---- 确认发货（a:"fahuo"） ----
    async submitShip () {
      if (!this.shipGoodsList || this.shipGoodsList.length === 0) {
        this.$message.warning('暂无物流单可发货')
        return
      }

      const hasValidQty = this.shipGoodsList.some(item => parseInt(item.quantity) > 0)
      if (!hasValidQty) {
        this.$message.warning('请至少有一个有效的发货数量')
        return
      }

      // 检查每个商品的总发货量是否超过订单数量
      for (const item of this.shipGoodsList) {
        const totalUsed = this.shipGoodsList
          .filter(g => g.goodsId === item.goodsId)
          .reduce((sum, g) => sum + (parseInt(g.quantity) || 0), 0)
        const original = this.originalGoodsList.find(g => g.goodsId === item.goodsId)
        const total = parseInt(original ? original.comlistS1 : 0)
        if (totalUsed > total) {
          this.$message.error(`商品「${item.goodsName}」发货总量（${totalUsed}）超过订单数量（${total}）`)
          return
        }
      }

      const jxId = localStorage.getItem('jx_id')
      if (!jxId) {
        this.$message.error('请先登录')
        return
      }

      // 构建商品列表（下划线字段）
      const goodsList = this.shipGoodsList
        .filter(item => parseInt(item.quantity) > 0)
        .map(item => {
          const original = this.originalGoodsList.find(g => g.goodsId === item.goodsId)
          return {
            order_mx_id: parseInt(original ? original.id : 0),
            goods_id: parseInt(item.goodsId),
            goods_name: item.goodsName,
            comlist_s2: parseInt(item.quantity),
            code: item.code || ''
          }
        })

      if (goodsList.length === 0) {
        this.$message.warning('没有有效的发货数据')
        return
      }

      const requestBody = {
        a: 'fahuo',
        sh_id: parseInt(this.shipOrder.brandId),
        jx_id: parseInt(jxId),
        order_id: parseInt(this.shipOrder.id),
        list: [
          {
            goods_list: goodsList
          }
        ]
      }

      console.log('确认发货请求参数:', requestBody)

      this.shipLoading = true
      try {
        const response = await request.post('/order/order_pai.php', requestBody, {
          headers: { 'Content-Type': 'application/json' }
        })

        if (response.code === '0') {
          this.$message.success(response.res || '发货成功！')
          this.shipDialogVisible = false
          // 刷新订单列表
          this.getOrderList()
        } else if (response.code === 1001) {
          this.$message.error('请先登录')
        } else {
          this.$message.error(response.msg || '发货失败，请重试')
        }
      } catch (error) {
        console.error('发货请求出错:', error)
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.shipLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.money {
  color: #ee530c;
  font-weight: 600;
}

.order-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }

    .no-action {
      color: #bbb;
      font-size: 14px;
    }
  }

  .detail-descriptions {
    margin-bottom: 20px;
  }

  .mx-section {
    margin-top: 16px;
    border-top: 1px solid #ebeef5;
    padding-top: 16px;

    .mx-title {
      margin: 0 0 12px 0;
      font-size: 15px;
      color: #303133;
    }
  }

  // ---- 发货弹窗样式 ----
  .ship-header {
    margin-bottom: 20px;
  }

  .ship-goods-section {
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .ship-title {
        margin: 0;
        font-size: 15px;
        color: #303133;
      }
    }

    .ship-total {
      margin-top: 16px;
      text-align: right;
      font-size: 15px;
      color: #303133;

      strong {
        color: #ee530c;
        font-size: 18px;
      }
    }
  }
}
</style>
